define(
	'AAMS.OffersExtension.Offers'
,   [
	  	'AAMS.OffersExtension.Offers.RightSide.View',
	  	'AAMS.OffersExtension.Offers.PopUp.Promo.View',
		'AAMS.OffersExtension.Offers.SignUp.Model',
		'Profile.Model',
		'AjaxRequestsKiller',
		'AAMS.OffersExtension.Offers.Mobile.View'
	]
,   function (
		OffersRightSideView,
		OffersPopUpPromoView,
		OffersSignUpModel,
		ProfileModel,
		AjaxRequestsKiller,
		MobileOffersView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			const environment = container.getComponent("Environment");
			const layout = container.getComponent('Layout');
			const pageType = container.getComponent('PageType');
			
			if(layout && environment)
			{
				layout.addToViewEventsDefinition(
				  'Header.Menu.View',
				  'click [data-action="hide-categories-nav"]',
				  function(e) {
				  	
				  	var self = this;
					var profile = ProfileModel.getInstance()
		            ,   is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'
		           	,	userId = profile.get('internalid')

				  	const anchor = jQuery(e.currentTarget);
				  	var link = jQuery(e.currentTarget).text().trim();
				  	var flag = $('.header-menu-level1').children().hasClass('open');
				  	//console.log(link)
				  	if(flag)
				  	{
				  		$('.header-menu-level1').find('li').removeClass("open");
				  		jQuery('#main').removeClass('nav-opened');
				  	}
				  	if(link == "Subscribe")
				  	{
				  		//Hide Wish list Right Side bar
				  		jQuery('.main').removeClass('wishlist-rightside-bar-opened');
			            jQuery('.sidebar-close-rightside-bar').hide();
			            jQuery('.wishlist-sidebar-overlay-sec').hide();
			            jQuery('.wishlist-secondary-wrapper-sec').hide();
			            //Hide Wish list Right Side bar

				  		jQuery('html').css('background','none');
			            jQuery('.main').addClass('offers-rightside-bar-opened');
			            jQuery('.offers-sidebar-close-rightside-bar').show();
			            jQuery('.offers-secondary-wrapper-sec').show();
			            jQuery('.header-secondary-wrapper-mobile').hide();
			            jQuery('.shopping-layout-header').css("box-shadow","none")

			            jQuery('.offers-sidebar-overlay-sec').show();
			            jQuery('.shopping-layout-header').removeClass('shopping-layout-header-no-hamburger-scroll')
			            jQuery('.myaccount-layout-header').removeClass('myaccount-layout-header-no-hamburger-scroll')
				  		jQuery('#show-offers').trigger('click',true);
				  	}
				  }
				);

				layout.addToViewEventsDefinition(
				  'Header.View',
				  'click [data-action="show-mobile-offers"]',
				  function(e) {
				  	
				  	var self = this;
					var profile = ProfileModel.getInstance()
		            ,   is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'
		           	,	userId = profile.get('internalid')

				  	const anchor = jQuery(e.currentTarget);
				  	//console.log(anchor)

				  	var popup = new MobileOffersView({
                        application : layout.application
                    })

                    if (popup)
                    layout.showContent(popup, {showInModal: true});
				  }
				);

				var languageNames = {en:'English', es:'Spanish', pt:'Portuguese', de:'German', ko:'Korean', it:'Italian', fr:'French', tr:'Turkish', ja:'Japanese', ar:'Arabic'};
				function updateSidebarLanguageLabel() {
					var savedLang = (document.cookie.match('(^|;)\\s*localizationlanguage=([^;]*)') || [])[2] || 'en';
					jQuery('.sidebar-current-language').text(languageNames[savedLang] || savedLang);
				}
				jQuery(document).on('click', '[data-action="header-sidebar-show"]', function() {
					updateSidebarLanguageLabel();
				});

				jQuery(document).on('click', '.header-sidebar-menu a[name="Subscribe"]', function(e) {
					e.preventDefault();
					e.stopPropagation();
					jQuery('[data-action="header-sidebar-hide"]').trigger('click');
					setTimeout(function() {
						var popup = new MobileOffersView({
							application : layout.application
						})
						if (popup)
						layout.showContent(popup, {showInModal: true});
					}, 300);
				});

				jQuery(document).on('click', '.header-sidebar-menu a[name="Language Selector"]', function(e) {
					e.preventDefault();
					e.stopPropagation();
					jQuery('[data-action="header-sidebar-hide"]').trigger('click');
					setTimeout(function() {
						var formContent = jQuery('.header-menu-settings-dropdown').html();
						jQuery('.mobile-language-modal').remove();
						var modalHtml = '<div class="modal fade mobile-language-modal" tabindex="-1">'
							+ '<div class="modal-dialog">'
							+ '<div class="modal-content">'
							+ '<div class="modal-header"><button type="button" class="global-views-modal-content-header-close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>'
							+ '<div class="modal-body country-language-dropdown-section">' + formContent + '</div>'
							+ '</div></div></div>';
						jQuery('body').append(modalHtml);

						jQuery('.mobile-language-modal #country').attr('id', 'modal-country');
						jQuery('.mobile-language-modal #language').attr('id', 'modal-language');
						jQuery('.mobile-language-modal #country-language-dropdown').attr('id', 'modal-country-language-dropdown');

						var savedCountry = (document.cookie.match('(^|;)\\s*localizationcountry=([^;]*)') || [])[2] || '';
						var savedLanguage = (document.cookie.match('(^|;)\\s*localizationlanguage=([^;]*)') || [])[2] || '';
						if(savedCountry && savedCountry.length <= 3) {
							jQuery('#modal-country').val(savedCountry);
						}
						if(savedLanguage) {
							jQuery('#modal-language').val(savedLanguage);
						}

						jQuery('.mobile-language-modal').modal('show');
						jQuery('.mobile-language-modal').on('hidden.bs.modal', function() {
							jQuery(this).remove();
						});
					}, 300);
				});

				jQuery(document).on('click', '.mobile-language-modal [data-action="submit-country-language"]', function(e) {
					e.preventDefault();
					var data = jQuery(e.target).closest('form').serializeObject();
					var country = data.country;
					var language = data.language;

					jQuery('.goog-te-combo').val(language);
					var combo = document.querySelector('.goog-te-combo');
					if(combo) {
						var event = new Event('change');
						combo.dispatchEvent(event);
					}

					if(country) {
						document.cookie = 'localizationcountry=' + country + '; path=/; expires=' + new Date(Date.now() + 30*24*60*60*1000).toUTCString();
						jQuery('#site-localization #site-country').text(country);
					}
					if(language) {
						document.cookie = 'localizationlanguage=' + language + '; path=/; expires=' + new Date(Date.now() + 30*24*60*60*1000).toUTCString();
						jQuery('#site-localization #site-language').text(language);
					}

					updateSidebarLanguageLabel();
					jQuery('.mobile-language-modal').modal('hide');
				});

				layout.addChildView('Offers.RightSide.Panel', function () {
		  			return new OffersRightSideView({
							application : layout.application,
						});
					
				});

				layout.addChildView('Offers.PopUpAD.Panel', function () {
		  			return new OffersPopUpPromoView({
							application : layout.application,
						});
					
				});
			}
		}
	};
});
